import type { InitData, MappedMenuLink } from '~/plugins/initData'

export type UseInitData = {
  globalConfig: ComputedRef<InitData['globalConfig']>
  siteInfo: ComputedRef<InitData['siteInfo']>
  mainMenuLinks: ComputedRef<MappedMenuLink[]>
}

export default function (): UseInitData {
  const data = useState<InitData | null>('initData', () => null)

  return {
    globalConfig: computed(() => data.value?.globalConfig || {}),
    mainMenuLinks: computed(() => data.value?.mainMenuLinks || []),
    siteInfo: computed(() => data.value?.siteInfo || {}),
  }
}
